import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/pro-regular-svg-icons/faGift';

import React, { useCallback } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { updateFulfillmentPlansIsGift } from '../../../../../../fulfillment-plans/fulfillment-plans.api';
import { useUpdateEntitiesFulfillmentPlans } from '../../../../hooks/use-update-entities-fulfillment-plans';
import { useHasFulfillmentPlanRestriction } from '../../../../fulfillment-plan/restrictions-context';
import { UiRestrictions } from '../../../../../../enums/component-states';

import messages from '../messages';

import style from './gift-checkbox.module.less';

const isGiftCheckboxInputId = 'is-gift-toggle';

export const GiftCheckbox = ({ showErrorNotification }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const isGift = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'isGift');
  const updateEntities = useUpdateEntitiesFulfillmentPlans();

  const onIsGiftChange = useCallback(
    async (isChecked) => {
      try {
        const { data: updatedEntityFulfillmentPlans } = await updateFulfillmentPlansIsGift([fulfillmentPlanId], isChecked);
        updateEntities(updatedEntityFulfillmentPlans);
      } catch {
        showErrorNotification();
      }
    },
    [fulfillmentPlanId, showErrorNotification, updateEntities],
  );

  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.IsGift);

  return (
    <div className={style['gift-banner']}>
      <Checkbox checked={isGift} disabled={isRestricted} inputId={isGiftCheckboxInputId} onChange={onIsGiftChange} />
      <label htmlFor={isGiftCheckboxInputId}>
        <FormattedMessage {...messages.gift} />
      </label>
      <FontAwesomeIcon className={classnames(style.icon, { [style['is-gift']]: isGift })} icon={faGift} />
    </div>
  );
};

GiftCheckbox.propTypes = {
  showErrorNotification: PropTypes.func.isRequired,
};
